import React, {useState} from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
//import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
//import imgRecommendations from "../../../assets/recommendations-cover-2.png";
import { useHistory } from "react-router-dom";

/* import imgGirl from "../../../assets/cover-girl.png"; */

interface FAQData {
  pregunta: string;
  respuesta: string;
}

interface FAQProps {
  datos: FAQData[];
}


function LandingFAQ({datos}: FAQProps) {
  const [preguntaActiva, setPreguntaActiva] = useState<number | null>(null);

  const handlePreguntaClick = (indice: number) => {
    if (preguntaActiva === indice) {
      setPreguntaActiva(null);
    } else {
      setPreguntaActiva(indice);
    }
  };

  const history = useHistory();

  function handleClick() {
    history.push('/signup/?user=1');
  }

  return (
    <div>
      <div className="faq" id="preguntas-frecuentes">
        <div className="landing-faq-title">
          <Typography variant="h1" component="h2" className="landing-title faq-title">
          Preguntas frecuentes
          </Typography>
        </div>
        <div className="landing-faq-content">
          <div className="faq-acordeon">
            {datos.map((dato, indice) => (
              <div className="question" key={indice}>
                <h2 onClick={() => handlePreguntaClick(indice)}>
                  {dato.pregunta}
                </h2>
                <div
                  className={`answer ${
                    preguntaActiva === indice ? 'activo' : ''
                  }`}
                >
                <p>{dato.respuesta}</p>
              </div>
            </div>
          ))}
          </div>
        </div>
      </div>
    </div>
  );
  /* return (
    <div>
      <div className="faq">
        <div className="landing-faq-title">
          <Typography variant="h1" component="h2" className="landing-title faq-title">
          Preguntas frecuentes
          </Typography>
        </div>
        <div class="landing-faq-content">
          <div class="faq-acordeon">
            <div class="question">
              <h2>¿Pregunta 1?</h2>
              <div class="answer">
                <p>Respuesta a la pregunta 1.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  ); */
}

export default LandingFAQ;